// import React from 'react'

// const CreateAgent = () => {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default CreateAgent




import React, { useEffect, useState, useContext } from "react";

import {
  Grid, Box,
  TextField,
  FormControl, Button,
  Stack,
  Breadcrumbs,
  Link,
  AppBar,
  Snackbar,
  Alert,
  Autocomplete
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useStyles } from "../../../assets/styles/Theme";
import AddToolbar from "../../../components/common/AddToolbar";
import Navbar from "../../../components/common/Navbar";
import {
  externalpostApi,
  externalgetApi,
} from "../../../services/external/externalApis";
import { useSelector } from "react-redux";
import {


  AGENT_API_01,
  Country_API_02,

} from "../../../api/ApiModel";

import {
  CON_STATUS_ACTIVE
} from "../../../utils/sys/Constants";

const CreateAgent = () => {
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, RESTCODE, GROUPCODE,USERNAME,LOCCODE } =
    SYS_USER.USER_PARAM || {};
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [data, setData] = useState([]);

  const [datasuppiler, setDatasuppiler] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    CREDITLIMIT: "0",
    DUEDAYS: "0",
    HOTLINE: "",
    CONTACTPERSON: "",
    NICPP: "",
    TITLE: "",
    FIRSTNAME: "",
    LASTNAME: "",
    EMAIL: "",
    CONTACTNO: "",
    COUNTRY: "",
    ADDRESSLINE1: "",
    ADDRESSLINE2: "",
    ADDRESSLINE3: "",
    GUESTTYPE: "",
    AGENTCODE: "",
  });

  const [errors, setErrors] = useState({});
  const [error, setError] = useState({});
  const [emailError, setEmailError] = useState("");
  const location = useLocation();
  const { selectedItem } = location.state || {};
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const isEdit = location.state?.actionText === "Edit";
  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        CREDITLIMIT: selectedItem.CREDITLIMIT,
        DUEDAYS: selectedItem.DUEDAYS,
        HOTLINE: selectedItem.HOTLINE,
        CONTACTPERSON: selectedItem.CONTACTPERSON,
        NICPP: selectedItem.NICPP,
        TITLE: selectedItem.TITLE,
        FIRSTNAME: selectedItem.FIRSTNAME,
        LASTNAME: selectedItem.LASTNAME,
        EMAIL: selectedItem.EMAIL,
        CONTACTNO: selectedItem.CONTACTNO,
        COUNTRY: selectedItem.COUNTRY,
        ADDRESSLINE1: selectedItem.ADDRESSLINE1,
        ADDRESSLINE2: selectedItem.ADDRESSLINE2,
        ADDRESSLINE3: selectedItem.ADDRESSLINE3,
        GUESTTYPE: selectedItem.GUESTTYPE,
        AGENTCODE: String(selectedItem.AGENTCODE),
      });
    }
  }, [selectedItem]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Clear the error for the specific field when the user starts typing
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(AGENT_API_01, "get", {
            COMPCODE,
               lOCCODE: LOCCODE,
                   STS: CON_STATUS_ACTIVE,
        });
        setDatasuppiler(result);
        console.log("Data fetched successfully:", result);
      } catch (err) {
        setError(err);
      }
    };

    fetchData();
  }, []);

  const handleConfirmClick = async () => {
    const {
      CREDITLIMIT,
      DUEDAYS,
      CONTACTPERSON,
      NICPP,
      FIRSTNAME,
      LASTNAME,
      EMAIL,
      CONTACTNO,
      ADDRESSLINE1,
    } = selectedItemDetails;

    const requiredFields = [
    //   { name: "CREDITLIMIT", value: CREDITLIMIT, label: "Credit Limit" },
    //   { name: "DUEDAYS", value: DUEDAYS, label: "Due Days" },
      { name: "NICPP", value: NICPP, label: "NIC" },

    

      { name: "FIRSTNAME", value: FIRSTNAME, label: "First Name" },
      { name: "LASTNAME", value: LASTNAME, label: "Last Name" },
         { name: "CONTACTNO", value: CONTACTNO, label: "Contact Number" },
//       { name: "EMAIL", value: EMAIL, label: "Email" },
//       { name: "CONTACTNO", value: CONTACTNO, label: "Contact Number" },
//   { name: "CONTACTPERSON", value: CONTACTPERSON, label: "Contact Person" },
//       { name: "ADDRESSLINE1", value: ADDRESSLINE1, label: "Address Line 1" },

      // { name: "GUESTTYPE", value: GUESTTYPE, label: "Guest Type" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`; // Set error message for each missing field
      });

      setErrors(newError); // Set the error state
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      const errorMessage = `Required fields: ${missingFieldLabels}.`;

      setSnackbarMessage(errorMessage); // Show snackbar with missing fields
      setOpenErrorSnackbar(true);
      return; // Stop submission if there are validation errors
    }
    // const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    // if (!validateEmail(EMAIL)) {
    //   setErrors((prevErrors) => ({
    //     ...prevErrors,
    //     EMAIL: "Please enter a valid email address.",
    //   }));
    //   setSnackbarMessage("Please enter a valid email address.");
    //   setOpenErrorSnackbar(true);
    //   return; // Stop further execution if the email is invalid
    // }

  if (datasuppiler) {
  const isDuplicate = datasuppiler.some(
    (item) =>
      item.NICPP === NICPP 
 

  );

  if (isDuplicate) {
    setSnackbarMessage("Agent NIC/PP already exists."); // More accurate message
    setOpenErrorSnackbar(true);
    return;
  }
}

    // Determine AGENTCODE based on whether it's an edit or not
    // const AGENTCODE = isEdit ? selectedItemDetails.AGENTCODE : "";
    const AGENTCODE = selectedItem
      ? String(selectedItem.AGENTCODE || "")
      : "";

    const staticValues = {
      COMPCODE,
      LOCCODE,
    
      STS: CON_STATUS_ACTIVE,
   
      Enuser: USERNAME,
   
      fax: "",
      AGENTCODE, // Include AGENTCODE in the payload
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(AGENT_API_01, payload);
      console.log("Success:", responseData);
      setOpenSnackbar(true);
      setSelectedItemDetails({
        CREDITLIMIT: "",
        DUEDAYS: "",
        HOTLINE: "",
        CONTACTPERSON: "",
        NICPP: "",
        TITLE: "",
        FIRSTNAME: "",
        LASTNAME: "",
        EMAIL: "",
        CONTACTNO: "",
        COUNTRY: "",
        ADDRESSLINE1: "",
        ADDRESSLINE2: "",
        ADDRESSLINE3: "",
        GUESTTYPE: "",
        AGENTCODE: "",
      });
    } catch (error) {
      console.error("Error:", error);
    }
  
  };

  const gotToView = () => {
    navigate("/AgentInfo");
  };

  const handleInputEmailValidation = (event) => {
    const { name, value } = event.target;
    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    // Update userDetails state first
    handleInputChange(event);

    // Validate the email input
    if (value.trim() === "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Email is required.", // Optional: check for empty input
      }));
    } else if (validateEmail(value)) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); // Clear error on valid email
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Please enter a valid email address.", // Set error message for invalid email
      }));
    }
  };

  const handleInputValidation = (event) => {
    const { name, value } = event.target;
    const regex = /^[a-zA-Z\s]*$/;

    if (regex.test(value)) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
      handleInputChange(event);
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Only letters and spaces are allowed.",
      }));
    }
  };

  const handletextnumInputValidation = (event) => {
    const { name, value } = event.target;
    const regex = /^[a-zA-Z0-9.\s]*$/;

    if (regex.test(value)) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
      handleInputChange(event);
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Only letters and spaces are allowed.",
      }));
    }
  };

  const handleNumberValidation = (event) => {
    const { name, value } = event.target;
    const regex = /^[0-9]*\.?[0-9]*$/;

    if (regex.test(value) && value.length <= 10) {
      // Valid input: matches regex and is within the 10-character limit
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
      handleInputChange(event); // Update state with valid input
    } else if (value.length > 10) {
      // Invalid: Exceeds 10 characters
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Input cannot exceed 10 characters.",
      }));
    } else {
      // Invalid: Does not match regex
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Only numbers and floats are allowed.",
      }));
    }
  };

  const handleClearClick = () => {
    setSelectedItemDetails({
      CREDITLIMIT: "",
      DUEDAYS: "",
      HOTLINE: "",
      CONTACTPERSON: "",
      NICPP: "",
      TITLE: "",
      FIRSTNAME: "",
      LASTNAME: "",
      EMAIL: "",
      CONTACTNO: "",
      COUNTRY: "",
      ADDRESSLINE1: "",
      ADDRESSLINE2: "",
      ADDRESSLINE3: "",
      GUESTTYPE: "",
    });
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(AGENT_API_01, "get", {
          COMPCODE,
         LOCCODE,
          STS: CON_STATUS_ACTIVE,
        });
        setData1(result);
      } catch (err) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          fetch: "Failed to fetch settings data",
        }));
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(Country_API_02, "get", {
          Country: "",
        });
        setData(result);
      } catch (err) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          fetch: "Failed to fetch country data",
        }));
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(AGENT_API_01, "get", {
          STS: CON_STATUS_ACTIVE,
        });
        setData2(result);
      } catch (err) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          fetch: "Failed to fetch guest type data",
        }));
      }
    };
    fetchData();
  }, []);

  const titles = ["Mr", "Mrs", "Ms"];

  return (
    <div>
    
      <Box sx={styles.AI_AddStyledBox_ag}>
        <AddToolbar
          label={{ name: isEdit ? " Agent Details" : " Agent Details" }}
        />

        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid item spacing={2} xs={12} sm={12} md={6} lg={6}>
            <Grid item xs={12} sm={12}>
              <TextField
                label="NIC / PP No"
                size="small"
                fullWidth
                required
                variant="outlined"
                autoComplete="off"
                name="NICPP"
                value={selectedItemDetails.NICPP}
                onChange={handleInputChange}
                 error={!!errors.NICPP}
                helperText={errors.NICPP}
              />
            </Grid>

  
            <Grid item xs={12} sm={12} mt={2}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={titles}
                  getOptionLabel={(option) => option}
                  value={selectedItemDetails.TITLE}
                  onChange={(event, newValue) => {
                    handleInputChange({
                      target: { name: "TITLE", value: newValue },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Title" size="small" />
                  )}
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                  noOptionsText={
                    <div
                      style={{
                        backgroundColor: theme.palette.background.paper,
                        padding: "8px",
                      }}
                    >
                      No options
                    </div>
                  }
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} mt={2}>
              <TextField
                label="First Name"
                size="small"
                fullWidth
                variant="outlined"
                autoComplete="off"
                required
                name="FIRSTNAME"
                value={selectedItemDetails.FIRSTNAME}
                onChange={handleInputValidation}
                error={!!errors.FIRSTNAME}
                helperText={errors.FIRSTNAME}
              />
            </Grid>
            <Grid item xs={12} mt={2}>
              <TextField
                label="Last Name"
                size="small"
                fullWidth
                variant="outlined"
                autoComplete="off"
                required
                name="LASTNAME"
                value={selectedItemDetails.LASTNAME}
                onChange={handletextnumInputValidation}
                error={!!errors.LASTNAME}
                helperText={errors.LASTNAME}
              />
            </Grid>
            <Grid item xs={12} mt={2}>
              <TextField
                label="Email"
                name="EMAIL"
                value={selectedItemDetails.EMAIL}
                type="email"
                // required
                onChange={handleInputEmailValidation}
                error={Boolean(errors.EMAIL)} // Set error state based on validation
                helperText={errors.EMAIL} // Display the error message
                variant="outlined"
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={12} mt={2}>
              <TextField
                label="Contact Number"
                size="small"
                fullWidth
                variant="outlined"
                autoComplete="off"
               required
                name="CONTACTNO"
                value={selectedItemDetails.CONTACTNO}
                onChange={handleNumberValidation}
                error={!!errors.CONTACTNO}
                helperText={errors.CONTACTNO}
              />
            </Grid>
            <Grid item xs={12} mt={2}>
              <TextField
                label="Hotline"
                size="small"
                fullWidth
                variant="outlined"
                autoComplete="off"
                name="HOTLINE"
                value={selectedItemDetails.HOTLINE}
                onChange={handleNumberValidation}
                error={!!errors.HOTLINE}
                helperText={errors.HOTLINE}
              />
            </Grid>
          </Grid>
          <Grid item spacing={2} xs={12} sm={12} md={6} lg={6}>
            <Grid item xs={12}>
              <TextField
                label="Address Line 1"
                name="ADDRESSLINE1"
                value={selectedItemDetails.ADDRESSLINE1}
                onChange={handleInputChange}
                fullWidth
                size="small"
                // required
                variant="outlined"
                error={!!errors.ADDRESSLINE1}
                helperText={errors.ADDRESSLINE1}
              />
            </Grid>
            <Grid item xs={12} mt={2}>
              <TextField
                label="Address Line 2"
                name="ADDRESSLINE2"
                value={selectedItemDetails.ADDRESSLINE2}
                onChange={handleInputChange}
                fullWidth
                size="small"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} mt={2}>
              <TextField
                label="Address Line 3"
                name="ADDRESSLINE3"
                value={selectedItemDetails.ADDRESSLINE3}
                onChange={handleInputChange}
                fullWidth
                size="small"
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} mt={2}>
              <Autocomplete
                id="country-autocomplete"
                options={data.map((item) => item.COUNTRY)}
                value={selectedItemDetails.COUNTRY}
                onChange={(event, newValue) =>
                  handleInputChange({
                    target: { name: "COUNTRY", value: newValue },
                  })
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Country"
                    size="small"
                    fullWidth
                  />
                )}
                ListboxProps={{
                  style: {
                    maxHeight: 150,
                    backgroundColor: theme.palette.background.paper,
                  },
                }}
                noOptionsText={
                  <div
                    style={{
                      backgroundColor: theme.palette.background.paper,
                      padding: "8px",
                    }}
                  >
                    No options
                  </div>
                }
              />
            </Grid>
            <Grid item xs={12} mt={2}>
              <TextField
                label="Due Days"
                size="small"
                fullWidth
                variant="outlined"
                autoComplete="off"
                // required
                name="DUEDAYS"
                value={selectedItemDetails.DUEDAYS}
                onChange={handleNumberValidation}
                error={!!errors.DUEDAYS}
                helperText={errors.DUEDAYS}
              />
            </Grid>
            <Grid item xs={12} mt={2}>
              <TextField
                label="Credit Limit"
                size="small"
                fullWidth
                variant="outlined"
                autoComplete="off"
                // required
                name="CREDITLIMIT"
                value={selectedItemDetails.CREDITLIMIT}
                onChange={handleNumberValidation}
                error={!!errors.CREDITLIMIT}
                helperText={errors.CREDITLIMIT}
              />
            </Grid>

            <Grid item xs={12} sm={12} mt={2}>
              <TextField
                label="Contact Person"
                size="small"
                fullWidth
                variant="outlined"
                autoComplete="off"
                name="CONTACTPERSON"
                value={selectedItemDetails.CONTACTPERSON}
                onChange={handleInputChange}
              />
            </Grid>
          </Grid>
        </Grid>
        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Stack>
      </Box>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ top: "10%", right: "10%" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          {isEdit ? " Updated Successfully!" : " Created Successfully!"}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorSnackbar}
        message={snackbarMessage}
        autoHideDuration={6000}
        onClose={handleErrorSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ top: "10%", right: "10%" }}
      >
        <Alert
          onClose={handleErrorSnackbarClose}
          severity="error"
          sx={{ width: "100%" }}
        >
          {snackbarMessage || "Please fill out all fields before submitting."}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default CreateAgent;
